import { Box, Button, CircularProgress, Dialog, Paper } from "@mui/material";
import { FC, useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useActionBookmarksContext } from "@context/ActionBookmarksContext";
import { Share } from "@mui/icons-material";
import { gameState } from "@/services/gameState";
import { initNavigationShare } from "@/services/navigatorService";

export const BookmarksQrCode: FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const { getReplayGameUrl } = useActionBookmarksContext();
  const teams = gameState("teams");

  const [replayUrl, setReplayUrl] = useState("");

  useEffect(() => {
    if (isOpen) {
      getReplayGameUrl().then((url) => {
        if (url) {
          setReplayUrl(url);
        } else {
          console.error("Failed to get replay URL for bookmarks QR code.");
        }
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (replayUrl) {
      console.log("Replay URL for bookmarks QR Code:", replayUrl);
    }
  }, [replayUrl]);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth={"lg"}>
      <Paper
        sx={{
          p: "2vw",
          width: "40vw",
          maxWidth: "100%",
          overflow: "hidden",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "2vw",
          flexDirection: "column",
        }}
      >
        {replayUrl ? (
          <>
            <Box
              sx={{
                aspectRatio: "1/1",
                height: "auto",
                maxWidth: "100%",
                width: "100%",
              }}
            >
              <QRCode
                value={replayUrl}
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                viewBox={`0 0 256 256`}
              />
            </Box>
            {!!navigator.share && (
              <Button
                startIcon={<Share />}
                onClick={() =>
                  initNavigationShare({
                    title: "Spiel mit Lesezeichen",
                    text: `${teams.team1.name} - ${teams.team2.name}` || "",
                    url: replayUrl,
                  })
                }
              >
                Teilen
              </Button>
            )}
          </>
        ) : (
          <CircularProgress variant={"indeterminate"} />
        )}
      </Paper>
    </Dialog>
  );
};
